<div id="cssloader" class="cssload-container" *ngIf="loader.getLoading()">
    <div class="container-loader">
        <div class="spinner-grow" style="width: 5rem; height: 5rem; 
        background-image: url(/assets/img/brand/alpuraAzHzMin.svg);" role="status"> </div>
        
        <h4 class="text-light mt-4" >{{loader.getText()}}</h4>
    </div>
</div>